<template>
  <div>
    <div v-if="loadingAltiris">
      <v-progress-circular
        indeterminate
        color="primary"
        size="20"
        class="mb-2"
      >
      </v-progress-circular>
      {{$t('components.altiris.load')}}
    </div>

    <div v-else>
      <p v-if="others.length > 0">
        {{$t('components.altiris.title')}}
      </p>

      <div>
        <v-slide-group
          multiple
          show-arrows
        >
          <v-slide-item
            v-for="(item, i) in others"
            :key="i"
          >
          <a @click="setValue(item)" class="cardLinkEquipo">
            <div class="deviceBox"
            v-if="others.length > 0 && !isChecked"
            :style="{padding: '0.5rem'}"
            >
              <p class="under mb-0">
                <v-icon>mdi-laptop</v-icon>
                  {{$t('components.altiris.name')}} {{ item.name }}
                  <!-- <span class="name__pc"></span> -->
              </p>
              <p class="mb-0">
                {{$t('components.altiris.cod')}} {{ item.codEquipo }}
              </p>
              <p class="mb-0">{{$t('components.altiris.showLastSession', [item.fechUltLogin] )}}</p>
              <p v-if="item.centro" class="mb-0">
                {{$t('components.altiris.centro')}} {{ item.centro }}
              </p>
              <p v-if="item.edificio" class="mb-0">
                {{$t('components.altiris.edificio')}} {{ item.edificio }}
              </p>
              <p v-if="item.floor" class="mb-0">
                {{$t('components.altiris.floor')}} {{ item.floor }}
              </p>
              <p v-if="item.section" class="mb-0">
                {{$t('components.altiris.seccion')}} {{ item.section }}
              </p>
              <p v-if="item.room" class="mb-0">
                {{$t('components.altiris.room')}} {{ item.room }}
              </p>
              <br />
            </div>
          </a>
          </v-slide-item>
        </v-slide-group>

        <v-checkbox
          v-if="others.length > 0"
          v-model="isChecked"
          :label="$t('components.altiris.not')">
        </v-checkbox>
      </div>

      <div class="titleAltiris" v-if="(others.length > 0 && isChecked) || others.length === 0">
        <div v-if="processedText">
          <p v-html="processedText" @click="handleLinkClick"></p>

          <v-row v-for="(link, index) in links" :key="index" v-show="visibleIndex === index">
            <v-col>
              <div class="container__media">
                <!-- X para cerrar -->
                <div class="close-button" @click="closeLink">×</div>

                <template v-if="link.type === 'image'">
                  <img class="media_link" :src="link.href" alt="Contenido" />
                </template>
                <template v-else-if="link.type === 'video'">
                  <iframe
                    ref="videoIframe"
                    class="media_link"
                    :src="link.href"
                    frameborder="0"
                    allowfullscreen
                    controlslist="nodownload"
                    @contextmenu.prevent
                  ></iframe>
                </template>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <v-col class="my-0 py-0">
      <v-row>
        <v-autocomplete
          v-if="(others.length >= 0 || isVisibility)"
          :outlined="!disabled"
          :filled="disabled"
          ref="autocomplete"
          v-model="value"
          :search-input.sync="query"
          :hide-details="'auto'"
          :label="label"
          :persistent-hint="hint !== ''"
          :hint="hint"
          :disabled="disabled"
          :loading="loading"
          :items="items"
          :placeholder="params.placeholder || label"
          :item-text="itemText"
          :item-value="params.value || 'id'"
          :multiple="isMultiple"
          :no-filter="true"
          :clearable="!required"
          :no-data-text="messageEmpty"
          :rules="rules"
          :hide-no-data="!isEmpty"
          @click="isEmpty = false"
          @keydown="handleSearch($event)"
          @change="emitInputData"
        >
          <template v-if="$slots.required" v-slot:prepend-inner>
            <slot name="required"></slot>
          </template>
          <template v-slot:message="{ message }">
            <span v-html="message" />
          </template>
          <template v-slot:no-data v-if="params.nodatamessage">
            <v-list-item>
              <v-list-item-title>
                {{params.nodatamessage}}
                <strong v-if="params.extraFilter">
                  {{$t('components.search.noDataMessage')}}
                  <v-icon
                    size="20"
                  >
                    mdi-filter-plus-outline
                  </v-icon>
                  {{$t('components.search.noDataMessageContinue')}}
              </strong>
              </v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:append >
            <v-icon v-if="!loading">mdi-magnify</v-icon>
            <v-progress-circular
              v-else
              color="primary"
              indeterminate
              size="25"
            >
            </v-progress-circular>
          </template>

          <template v-slot:selection="data" v-if="isMultiple">
            <v-chip
              class="mt-2"
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="remove(data.item)"
            >
              {{ itemText(data.item) }}
            </v-chip>
          </template>
          <template v-slot:append-outer>
            <v-btn
              icon
              color="primary"
              @click="openModal = !openModal"
              v-if="params.extraFilter"
            >
              <v-icon
                size="30"
                class="mb-4"
              >
                mdi-filter-plus-outline
              </v-icon>
            </v-btn>
            <ExtendedSearch
              v-if="params.extraFilter && openModal"
              :filtersSearch="evalParam(params.extraFilter)"
              :filters="evalParam(params.filters)"
              :params="params"
              :title="label"
              @close="openModal = false"
              @send="getResultExtendedSearch($event)"
            >
            </ExtendedSearch>

            <v-btn
              icon
              color="primary"
              @click="barCodeScannerClick()"
              v-if="isMobile && isBarcodeScan"
            >
              <v-icon
                size="30"
                class="mb-4"
              >
                mdi-camera
              </v-icon>
            </v-btn>
          </template>
        </v-autocomplete>
      </v-row>
      <v-row>
        <span v-if='barCodeNotFound'>
        {{ $t('components.barCodeScanner.barCodeNotFound', [barCode]) }}
        </span>
      </v-row>
    </v-col>
  </div>
</template>
<script>
import Search from '../field-types/Search.vue';

export default {
  name: 'AltirisSearch',
  extends: Search,
  data() {
    return {
      isChecked: false,
      isVisibility: false,
      visibleIndex: null,
      processedText: '',
    };
  },
  methods: {
    async setValue(item) {
      this.isVisibility = true;
      let filters;
      if (item.serial_number !== null) {
        filters = { filters: { serial_number: item.serial_number } };
      } else {
        filters = { filters: { own_resource_uuid: item.CMDB_ASSET_ID } };
      }
      const result = await this.search(filters);
      if (result != null) {
        const valueItem = result.unique();
        this.value = valueItem;
        this.defaultItem = valueItem;

        this.items = result.list;
        this.lastSearch = this.itemText(result.unique());
        // force update to emit item and value event to update context
        this.$emit('update:inputData', {
          value: this.valueAttributeItem(this.value),
          item: this.value,
        });
      }
    },

    async searchAltirisBarCode(barCode) {
      this.barCode = barCode;
      try {
        this.barCodeNotFound = false;
        const filters = {
          inactive: 0,
          resource_class: {
            $in: [1000091, 1000597, 1000046],
          },
          status: 2606,
          $or: [
            { name: { $regex: `%${barCode}%` } },
            { zcod_sas: { $regex: `%${barCode}%` } },
            { serial_number: { $regex: `%${barCode}%` } }],
        };
        const result = await this.search({ filters });
        this.barCodeNotFound = result.length === 0;
        const valueItem = result.unique();
        this.value = valueItem;
        this.defaultItem = valueItem;
        this.items = result.list;
        this.lastSearch = this.itemText(valueItem);

        // force update to emit item and value event to update context
        this.$emit('update:inputData', {
          value: this.valueAttributeItem(this.value),
          item: this.value,
        });
      } catch (e) {
        this.barCodeNotFound = true;
      }
    },
    prepareDynamicLinks() {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.params.textLinkMedia, 'text/html');
      const anchorTags = doc.querySelectorAll('a');

      this.links = [];

      anchorTags.forEach((a, index) => {
        const href = a.getAttribute('href');
        const type = a.getAttribute('data-type') || 'image';
        this.links.push({ href, type });

        a.setAttribute('href', '#');
        a.setAttribute('data-index', index);
      });

      this.processedText = doc.body.innerHTML;
    },
    handleLinkClick(event) {
      const { target } = event;
      if (
        target
        && target.tagName === 'A'
        && target.dataset.index !== undefined
      ) {
        event.preventDefault();

        this.visibleIndex = Number(target.dataset.index);

        if (target.dataset.type === 'image') {
          this.pauseVideo();
        }
      }
    },
    closeLink() {
      this.visibleIndex = null;
      this.pauseVideo();
    },
    pauseVideo() {
      let iframe = this.$refs.videoIframe;
      // eslint-disable-next-line prefer-destructuring
      if (Array.isArray(iframe)) iframe = iframe[0];

      if (!iframe) return;

      const currentSrc = iframe.src;
      iframe.src = '';
      this.$nextTick(() => {
        iframe.src = currentSrc;
      });
    },
  },

  async created() {
    this.loadingAltiris = true;
    this.client = this.$api.getClient('search');

    // if initial value provided we will make a search to select the default row
    const { initialsearch } = this.params;

    if (initialsearch != null) {
      const { entity, params } = this.evalParam(initialsearch);
      // 1000118
      if (entity == null || params == null) {
        console.error('invalid initial search configuration: entity and params fields are mandatory');
        return;
      }

      try {
        console.log('OTHERS', { entity, params });
        const result = await this.client.search({ target: 'namedquery', entity, filters: params });
        if (result != null) {
          this.others = result.list;
        }
        this.loadingAltiris = false;
      } catch (ex) {
        console.error('error in initialsearch', ex);
      }
    }
  },
  mounted() {
    if (this.params && this.params.textLinkMedia) {
      this.prepareDynamicLinks();
    }
  },
};
</script>
<style>
  .name__pc {
    text-decoration: underline;
  }

  .v-slide-group__content {
    gap: 2rem !important
  }

  .v-slide-group__next, .v-slide-group__prev {
    min-width: none !important;
    border: 1px solid #eee;
  }

  .v-slide-group__next--disabled {
    display: none !important;
  }
  .deviceBox{
    border: 2px solid #ffffff00;
  }

  .deviceBox:hover {

    background-color: #e6f1ee;
    /*padding: 1em 0em;
    margin-bottom: 1em;
    margin-top: 1em;*/

    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 7%),
    0px 2px 2px 0px rgb(0 0 0 / 5%), 0px 1px 5px 0px rgb(0 0 0 / 5%);
    border: 2px solid #27846d;
    border-radius: 10px;
    /*background-color: #27846d50;*/
  }
  .cardLinkEquipo{
    color: rgba(0, 0, 0, 0.87) !important;
  }
  .labelCardEquip{
    /*font-weight: bold;*/
  }
  .labelCardEquip2{
    font-weight: bold;
    color: #27846d;
  }
  .labelCardEquip3{
    color: #27846d;
  }
  .iconLabel{
    color: #27846d;
  }

  .mb {
    margin-bottom: 1rem;
  }

  .v-application .v-input--description {
    > p {
      margin-bottom: 0;
    }

    &.v-input--description--next > p {
      margin: 20px 0 -10px 0;
    }
  }

  .container__media {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
  }

  .container__media iframe,
  .container__media .media_link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
  }

  @media (min-width: 900px) {
    .container__media {
      width: 40rem;
      padding-bottom: calc(40rem * 9 / 16);
    }
  }
</style>
